var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-checkbox", {
    attrs: {
      label: _vm.clientRole.label,
      ripple: false,
      indeterminate: _vm.indeterminateState,
      "hide-details": "",
      color: "#4fa2b7"
    },
    on: {
      change: function($event) {
        return _vm.selectClientRole(_vm.clientRole)
      },
      click: function($event) {
        $event.stopPropagation()
      }
    },
    model: {
      value: _vm.roleIsSelected,
      callback: function($$v) {
        _vm.roleIsSelected = $$v
      },
      expression: "roleIsSelected"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a18b41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a18b41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/Permissions/PermissionsClientRoleItem.vue
// module id = null
// module chunks = 